import { myAlertsClient } from '@y2/api-clients/my-alerts';

export const myAlerts = myAlertsClient();
